<template>
<div class="lang">
  <div class="banner"></div>
  <div class="detail-box">
    <div class="release-time">发布时间：{{jobInfo.createTime}}</div>
    <div class="position-common-box position-name-location">
      <div class="position-name">{{jobInfo.name}}</div>
      <div class="position-location">
        <div class="pos-loc-img"></div>
        <div class="pos-loc">{{jobInfo.location}}</div>
      </div>
    </div>
    <div class="position-common-box position-desc-salary">
      <div class="position-desc">{{jobInfo.title}} | {{jobInfo.jobType}} | {{jobInfo.experience}} | 招聘人数：{{jobInfo.headCount}}人</div>
      <div class="position-salary">{{jobInfo.salary}}</div>
    </div>
    <div class="line"></div>

    <div v-if="jobInfo.desc">
      <div  class="position-desc-box">
        <div class="title">职位描述：</div>
        <pre class="desc-p">
{{jobInfo.desc}}
        </pre>
        <pre class="desc-p"></pre>
      </div>
    </div>

    <div v-else>
      <div class="position-desc-box">
        暂无职位描述信息
      </div>
    </div>

    <div class="email">投递邮箱：hire@turingsenseai.com</div>
    <div class="back" @click="backRouter">返回职位列表</div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import { detail } from 'api/join'
import { Message } from 'element-ui'
export default {
  components: {},
  // 路由进入生命周期函数
  beforeRouteEnter (to, from, next) {
    // from 上一个页面路由地址
    // next 放行
    if (to.params.id) {
      next(vm => {
        vm.getDetailInfo(vm.$route.params.id)
      })
    } else {
      Message.error('没有当前职位信息')
    }
  },
  mounted () {
    this.$i18n.locale === 'zh' ? this.language = 0 : this.language = 1 // 数据加载时判断当前属于哪种语言，为其单选按钮赋值
  },
  data () {
    return {
      language: 0,
      jobInfo: {},
      lang: [{
        label: this.$t('message.zh'), // 模板语法的一种
        value: 0
      }, {
        label: this.$t('message.en'),
        value: 1
      }]
    }
  },
  // 侦听器
  watch: {
    language: function (val) { // 侦听单选按钮的变化，从而进行切换语言
      val === 0 ? this.$i18n.locale = 'zh' : this.$i18n.locale = 'en'
      Vue.set(this.lang, 0, { label: this.$t('message.zh'), value: 0 })
      Vue.set(this.lang, 1, { label: this.$t('message.en'), value: 1 })
    },
    '$route.path': function (newVal, oldVal) {
      console.log(newVal)
    }
  },
  methods: {
    getDetailInfo (id) {
      document.documentElement.scrollTop = 0
      detail({
        id
      }).then(res => {
        if (res.errorMsg === 'Success') {
          this.jobInfo = res.job
        } else {
          // todo
        }
      })
    },
    backRouter () {
      this.$router.go(-1)
    }
  }
}

</script>
<style lang="scss" scoped>
  @import './detail.scss';
</style>
